import { useCallback, useEffect, useState } from 'react';

const DEFAULT_TIMEOUT_MS = 30000;

export function useLoadingRecovery({
  active = true,
  timeoutMs = DEFAULT_TIMEOUT_MS,
} = {}) {
  const [needsManualReload, setNeedsManualReload] = useState(false);

  const triggerRecovery = useCallback(() => {
    setNeedsManualReload(true);
    return false;
  }, []);

  useEffect(() => {
    if (!active || timeoutMs <= 0) {
      setNeedsManualReload(false);
      return undefined;
    }

    setNeedsManualReload(false);

    const timer = window.setTimeout(triggerRecovery, timeoutMs);

    return () => {
      window.clearTimeout(timer);
    };
  }, [active, timeoutMs, triggerRecovery]);

  const reloadNow = () => {
    window.location.reload();
  };

  return {
    needsManualReload,
    reloadNow,
    triggerRecovery,
  };
}
